import { render } from "./homemain.vue?vue&type=template&id=63218548&scoped=true"
import script from "./homemain.vue?vue&type=script&lang=js"
export * from "./homemain.vue?vue&type=script&lang=js"

import "./homemain.vue?vue&type=style&index=0&id=63218548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63218548"]])

export default __exports__